// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.4_@module-federation+runtime-tools@2.9.0__webpack@5.110.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.4_@module-federation+runtime-tools@2.9.0__webpack@5.110.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout.app-root {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.app-main-content {
  padding: 32px;
  background: white;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
